module.exports = __webpack_public_path__ + "static/media/parcours.a9217d9b.png";